<chart [type]="'bar'" [data]="barData" [options]="barOptions"></chart>